import { useMemo } from 'react'

import { useScan } from '@hooks/useScan.ts'
import { useScansOfCurrentStore } from '@state/scans.ts'
import { calculateScanDates } from '@utils/scanDates.ts'

function useAvailableScanDates() {
  const { data: scans = [] } = useScansOfCurrentStore()
  const { scanDate } = useScan()

  return useMemo(
    () => calculateScanDates(scans, scanDate),
    [scans, scanDate]
  )
}

export default useAvailableScanDates